export default {
  yourPatrimony: 'Votre patrimoine',
  yourPatrimonyMinor: 'Le patrimoine de votre enfant',
  yourFinancialAssets: 'Vos actifs financiers',
  patrimonyRepartition: 'Répartition du patrimoine',
  patrimonyDescription:
    'Synthèse du patrimoine incluant l’ensemble des biens, de l’épargne et des engagements, valorisés en pleine propriété (même lorsqu’ils font l’objet d’un démembrement) et prenant en compte la quote-part effectivement détenue. Cette synthèse repose sur les informations déclarées par le client et sur les données patrimoniales disponibles dans les systèmes de la Banque.',
  patrimonyDescriptionPro:
    'Cette synthèse repose sur les informations déclarées par le client et sur les données patrimoniales disponibles dans les systèmes de la Banque.',
  patrimonySummaryExcludingCredit: 'Synthèse de votre patrimoine (hors crédit)',
  patrimonySummaryExcludingCreditMinor:
    'Synthèse du patrimoine de votre enfant (hors crédit)',
  financialAssetsSummary: 'Synthèse de vos actifs financiers',
  securitiesDisclaimer:
    '*Valeurs mobilières : pour les besoins de ce graphique, il s’agit des titres financiers qui ne sont pas inscrits sur un compte-titres ou un PEA (titre non coté, par exemple).',
  securitiesDisclaimerPro:
    '*Valeurs mobilières : pour les besoins de ce graphique, il s’agit des titres financiers qui ne sont pas inscrits sur un compte-titres ou en contrat de capitalisation.',
  tableHeaders: {
    nature: 'Nature',
    category: 'Catégorie',
    amount: 'Montant',
    totalGlobal: 'Total Patrimoine Global',
    totalNet: 'Total Patrimoine Net',
  },
  categories: {
    liquidities: 'Liquidités',
    financial: 'Financier',
    realEstate: 'Immobilier',
    credit: 'Crédit',
    divers: 'Divers',
  },
  playground: {
    newAsset: 'Nouvel Actif',
    assetNatureLabel: 'Nature (ex: Compte Courant)',
    assetCategoryLabel: 'Catégorie (ex: Liquidités)',
    assetAmountLabel: 'Montant (€)',
  },
}
